export default "__VITE_ASSET__D7r5ffqe__"